export const OpenAIP = () => {
    const L = window['L']

    return L.tileLayer('https://api.tiles.openaip.net/api/data/openaip/{z}/{x}/{y}.{ext}?apiKey={apiKey}', {
        attribution: '<a href="https://www.openaip.net/">OpenAIP Data</a> Not for navigational use! (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-NC-SA</a>)',
        ext: 'png',
        minZoom: 4,
        maxZoom: 14,
        subdomains: 'abc',
        apiKey: '3d5d3f82528731731362a23f445951d8'
    });
}
export const Jawg_Sunny = () => {
    const L = window['L']

    return L.tileLayer('https://{s}.tile.jawg.io/jawg-sunny/{z}/{x}/{y}{r}.png?access-token={accessToken}', {
        attribution: '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        minZoom: 0,
        maxZoom: 22,
        subdomains: 'abcd',
        accessToken: 'fV8nbLEqcxdUyjN5DXYn8OgCX8vdhBC5jYCkroqpgh6bzsEfb2hQkvDqRQs1GcXX'
    });
}

export const googleArial = () => {
    const L = window['L']

    return L.tileLayer('http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}', {
        attribution: 'google'
    })
}
